import React from 'react';
import styles from './styles.scss';
const Title = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.title,
    "data-hook": "share-title"
  }, text);
};
export default Title;
//# sourceMappingURL=title.js.map